
import Setting from "../../../assets/duotone/Setting.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SettingIcon({ className, dataTestid = "SettingIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Setting data-testid={dataTestid} className={classes} {...rest} />
  );
}
